import React from "react";

const OnlineCOnsultationIcon = () => {
  return (
    <svg
      width="48"
      height="35"
      viewBox="0 0 48 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7262 25.5645H21.4762V18.7903H28.9762V15.4032H21.4762V8.62904H17.7262V15.4032H10.2262V18.7903H17.7262V25.5645ZM5.36995 34.0323C4.10745 34.0323 3.0387 33.6371 2.1637 32.8468C1.2887 32.0565 0.851196 31.0909 0.851196 29.9502V4.24331C0.851196 3.10261 1.2887 2.1371 2.1637 1.34678C3.0387 0.556454 4.10745 0.161293 5.36995 0.161293H33.8318C35.0943 0.161293 36.1631 0.556454 37.0381 1.34678C37.9131 2.1371 38.3506 3.10261 38.3506 4.24331V14.5785L47.1487 6.63178V27.5618L38.3506 19.6151V29.9502C38.3506 31.0909 37.9131 32.0565 37.0381 32.8468C36.1631 33.6371 35.0943 34.0323 33.8318 34.0323H5.36995ZM5.36995 30.6452H33.8318C34.056 30.6452 34.2402 30.5801 34.3843 30.4498C34.5289 30.3196 34.6012 30.1531 34.6012 29.9502V4.24331C34.6012 4.04046 34.5289 3.87393 34.3843 3.74371C34.2402 3.6135 34.056 3.54839 33.8318 3.54839H5.36995C5.14578 3.54839 4.96161 3.6135 4.81745 3.74371C4.67328 3.87393 4.6012 4.04046 4.6012 4.24331V29.9502C4.6012 30.1531 4.67328 30.3196 4.81745 30.4498C4.96161 30.5801 5.14578 30.6452 5.36995 30.6452Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default OnlineCOnsultationIcon;
